import Script from 'next/script';

import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';

const UnidaysDiscount = () => {
  return (
    <>
      <Script
        src="https://access.myunidays.com/unidays-partner-component.min.js"
        strategy="afterInteractive"
        crossOrigin="anonymous"
      />
      <Main
        meta={
          <Meta
            title={'Student Discount'}
            description={'My Muscle Chef Discount'}
            canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/unidays`}
            noIndexing={true}
          />
        }
      >
        <div className="h-[920px] w-full sm:h-[720px]">
          <unidays-access
            clientid={`${process.env.NEXT_PUBLIC_UNIDAYS_CLIENT_ID}`}
            redirecturi={`${process.env.NEXT_PUBLIC_UNIDAYS_REDIRECT_URL}`}
            locale="en-AU"
            mobileimage="https://www.datocms-assets.com/81001/1728882356-unidays-desktop.jpg"
            desktopimage="https://www.datocms-assets.com/81001/1728882356-unidays-desktop.jpg"
            imagealttext="My Muscle Chef Unidays Discount Banner"
            partnerid={`${process.env.NEXT_PUBLIC_UNIDAYS_PARTNER_ID}`}
          ></unidays-access>
        </div>
      </Main>
    </>
  );
};

export default UnidaysDiscount;
